module.exports = __webpack_public_path__ + "static/media/student-end-season-silver.4618dac4.png";